import { useFormik } from "formik";
import { ModalComponent } from "..";
import { formatDate } from "../../../helperFunctions";
import { bulkUploadNameSchema } from "../../../validationSchema";
import { TextInput } from "../../inputs/textInput";

export const BulkEntryFileNameModal = ({
  modalOpen,
  handleModalClose,
  onSuccess,
  loading = false,
}: {
  modalOpen: boolean;
  handleModalClose: () => void;
  onSuccess: (data: { name: string; reset: () => void }) => void;
  loading?: boolean;
}) => {
  const reset = () => {
    resetForm();
    handleModalClose();
  };

  const {
    values,
    errors,
    handleChange,
    handleBlur,
    touched,
    isValid,
    resetForm,
    handleSubmit,
  } = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema: bulkUploadNameSchema,
    onSubmit: async (vals) => {
      onSuccess({
        name: vals.name,
        reset: () => {
          reset();
        },
      });
      return;
    },
  });

  return (
    <>
      <ModalComponent
        isModalOpen={modalOpen}
        onModalClose={() => {
          reset();
        }}
        title="Name this upload"
        hasButtons
        isLoading={loading}
        isProceedDisabled={!isValid || loading}
        proceedButtonText="Proceed"
        onProceedClick={() => {
          handleSubmit();
        }}
        hasCancelButton={false}
        childrenClassName=""
        topTitle
      >
        <TextInput
          type="text"
          name="name"
          value={values?.name}
          placeholder={`e.g. ${formatDate(new Date(), "MMMM YYYY")} Upload`}
          onChange={handleChange}
          onBlur={handleBlur}
          hasIcon={false}
          iconSvg={undefined}
          errors={errors?.name && touched?.name ? errors?.name : ""}
          autoComplete="off"
        />
      </ModalComponent>
    </>
  );
};
